var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTech4Dev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 39,
    viewBox: "0 0 224 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.526 9.146V38.717H147.164L145.12 36.4973V18.1992L147.906 15.5843H163.561V10.6452L167.526 9.146ZM163.561 19.4136H149.015V34.8935H163.561V19.4136Z",
    fill: "#213642"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.403 0H163.561V6.18847L167.403 4.71253V0Z",
    fill: "#ED1C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8786 18.7803V38.717H12.0129V18.7803H1.41455V15.6309H26.5236V18.7803H15.8786Z",
    fill: "#213642"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0945 38.717V15.6309H50.4357V18.7338H31.9776V25.1721H43.2592V28.2286H31.9776V35.5502H50.6109V38.717H28.0945Z",
    fill: "#213642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5229 18.7802H58.4414V35.5036H74.5229V29.6929L78.4118 30.5006V33.2316C78.4118 35.3584 78.0381 36.7994 77.2907 37.5548C76.5433 38.3102 75.1165 38.6976 73.0105 38.717H60.018C57.908 38.717 56.4755 38.3296 55.7202 37.5548C54.9553 36.7936 54.5524 35.3526 54.5524 33.2433V21.1046C54.5524 18.9894 54.9319 17.5542 55.7202 16.7872C56.5085 16.0201 57.91 15.625 60.018 15.625H73.0105C75.1204 15.625 76.5472 16.0124 77.2907 16.7872C78.0342 17.5619 78.4079 19.0011 78.4118 21.1046V23.2894L74.5229 24.0099V18.7802Z",
    fill: "#213642"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6498 38.717V15.6309H87.5271V25.0675H105.81V15.6309H109.67V38.717H105.81V28.2577H87.5271V38.717H83.6498Z",
    fill: "#213642"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.694 38.7173V33.2145H115.135V30.3498L131.859 15.3696H136.245V30.3498H141.558V33.2145H136.245V38.7173H132.694ZM132.694 30.3498V18.1472L119.217 30.3498H132.694Z",
    fill: "#213642"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172.553 38.717V15.6309H194.895V18.7338H176.437V25.1721H187.718V28.2286H176.437V35.5502H195.07V38.717H172.553Z",
    fill: "#213642"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M207.484 38.717L194.819 15.6309H198.994L209.242 34.8703L219.029 15.6309H222.871L210.737 38.717H207.484Z",
    fill: "#213642"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTech4Dev);
export default __webpack_public_path__ + "static/media/tech4dev.45a8aec846c65911291ebb28cab1e537.svg";
export { ForwardRef as ReactComponent };